var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventDetailsCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.003,
    height: 132.658,
    viewBox: "0 0 88.003 132.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_185949",
    "data-name": "Group 185949",
    transform: "translate(0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_185946",
    "data-name": "Group 185946",
    transform: "translate(0 0)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185947",
    "data-name": "Group 185947",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18052",
    "data-name": "Path 18052",
    d: "M16.187,130.326c-.943-.249-1.894-.467-2.829-.751C5,127.035-.606,118.423.052,109.157c.675-9.491,7.379-17.231,16.1-18.12,4.254-.433,8.567-.182,12.853-.238.487-.007.973,0,1.547,0V82.086a63.222,63.222,0,0,1-6.947-1.948c-13.1-5.274-20.614-15.452-22.4-30.494a52.89,52.89,0,0,1-.2-6.094q-.027-15.331,0-30.662C1.021,7.028,4.274,2.141,9.252.4c.383-.134.78-.222,1.4-.4V4.553c0,.708-.039,1.419.009,2.123a3.487,3.487,0,0,1-.907,2.68,5.742,5.742,0,0,0-1.273,3.3c-.048,11.944-.264,23.9.149,35.831.42,12.14,9.48,22.795,20.493,25.009C44.086,76.506,57.8,65.741,59.75,49.436a33.989,33.989,0,0,0,.168-3.975c.013-10.486-.005-20.972.019-31.459,0-1.916-.369-3.585-1.859-4.8a1.143,1.143,0,0,1-.367-.763c-.027-2.6-.016-5.2-.016-7.971A11.979,11.979,0,0,1,66.65,8.937a16.92,16.92,0,0,1,.7,4.943c.061,10.486.037,20.972.029,31.459C67.363,64.161,55.7,78.883,38.534,81.764a2.781,2.781,0,0,0-.413.15V90.8H39.55c7.925,0,15.851-.112,23.774.039,5.387.1,10.092-1.311,13.5-5.633l7.782,1.91a20.3,20.3,0,0,1-4.357,5.737,21.016,21.016,0,0,1-14.7,5.938q-23.161.046-46.322.038c-4.121-.006-7.539,1.438-9.908,5.192-4.544,7.2-.425,17.035,7.584,18.13,3.743.511,7.261-.032,10.178-2.935a12,12,0,0,0,3.547-8.451c.038-1.23.006-2.462.006-3.781h7.247c1.54,12.072-5.7,21.3-15,23.066-.356.068-.7.182-1.057.275Z",
    transform: "translate(0 2.332)",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18053",
    "data-name": "Path 18053",
    d: "M3.609,0A3.615,3.615,0,1,1,0,3.609,3.618,3.618,0,0,1,3.609,0",
    transform: "translate(80.762 70.809)",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18054",
    "data-name": "Path 18054",
    d: "M5.785.006V7.779a9.534,9.534,0,0,1-3.213-.226A3.888,3.888,0,0,1,3.77.008c.656-.017,1.313,0,2.015,0",
    transform: "translate(38.731)",
    fill: "#61277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18055",
    "data-name": "Path 18055",
    d: "M0,.035A17.735,17.735,0,0,1,2.4.053a3.814,3.814,0,0,1,3.323,3.9A3.812,3.812,0,0,1,2.28,7.734,20.432,20.432,0,0,1,0,7.748Z",
    transform: "translate(18.851 0.007)",
    fill: "#61277F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_185948",
    "data-name": "Group 185948",
    transform: "translate(36.906 3.729)",
    opacity: 0.5,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_185877",
    "data-name": "Group 185877",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17952",
    "data-name": "Path 17952",
    d: "M51.936,14.075v2.1a2.77,2.77,0,0,0-.074.336,15.044,15.044,0,0,1-4.507,9.427q-10.3,10.307-20.612,20.609a14.9,14.9,0,0,1-9.88,4.522A14.5,14.5,0,0,1,7.807,48.71a14.627,14.627,0,0,1-6.87-11.1A14.673,14.673,0,0,1,5.394,25.194Q15.7,14.852,26.038,4.546A14.883,14.883,0,0,1,33.463.4C34.223.231,35,.13,35.764,0h2.1A1.184,1.184,0,0,0,38.1.068a14.6,14.6,0,0,1,6.947,2.38A14.728,14.728,0,0,1,51.337,11c.279,1,.4,2.046.6,3.071m-17.3,17.992a1.421,1.421,0,0,0,.115-.094c3.141-3.14,6.309-6.253,9.414-9.429a10.227,10.227,0,0,0,2.691-10.379A10.448,10.448,0,0,0,29.268,7.879Q24.7,12.454,20.13,17.02c-.1.1-.189.213-.257.291L34.634,32.067m-29.146,3.5a4.851,4.851,0,0,0,.035.668,1.035,1.035,0,0,0,.845.877,1,1,0,0,0,1.173-.445,2.142,2.142,0,0,0,.259-.937,7.707,7.707,0,0,1,2.133-5.186c2.279-2.355,4.617-4.653,6.927-6.977a3.217,3.217,0,0,0,.446-.533,1.033,1.033,0,0,0,.008-1.13.96.96,0,0,0-1.025-.556,2.046,2.046,0,0,0-.98.51q-3.362,3.308-6.68,6.66a10.442,10.442,0,0,0-3.14,7.05",
    transform: "translate(-0.839 0.001)",
    fill: "#61277F"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDetailsCard);
export default __webpack_public_path__ + "static/media/event-details-card.7768815363461c3764b420bd3605700e.svg";
export { ForwardRef as ReactComponent };